import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://defender.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://defender.compo-soft.ru/documents';
  serverApi =  'https://defender.compo-soft.ru/api/v1';
  serverUrl =  'https://defender.compo-soft.ru';
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  #impersonatePortalPath = 'https://defender.compo-soft.ru/';
  impersonate = false;
  accessRolesCatalog = true;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  publicShowcase = false;
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminTest();
